var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-content"},[_c('img',{staticClass:"error-img",attrs:{"src":require("../../assets/img/error.png")}}),_c('p',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }